module.exports = __webpack_public_path__ + "static/media/infiniti-icon-noneOption.7c141ed5.svg";